// pending, then approved or rejected by an admin (the Approve / Reject actions), then
// executed or failed by core-cron, which applies an approved appeal to its transaction.
export const APPEAL_STATUS = ['pending', 'approved', 'rejected', 'executed', 'failed'];
